module.exports = __webpack_public_path__ + "static/media/jakarta-timur.38402444.svg";